import React, { useEffect, useState } from 'react';
import { useI18n } from '../../i18n/LanguageContext';
import { useMedia } from '../../site/MediaProvider';
import { PublicCertification } from '../../types';
import { PublicApi } from '../../utils/apiClient';
import { fallbackCertifications } from '../../data/fallback';
import { Award, Leaf, ShieldCheck } from 'lucide-react';
import FadeIn from './FadeIn';

const CERT_ICON: Record<string, React.FC<{ size?: number; color?: string; 'aria-hidden'?: boolean }>> = {
  award: Award, leaf: Leaf, shield: ShieldCheck,
};
const certIcon = (k?: string | null) => CERT_ICON[(k || '').toLowerCase()] || ShieldCheck;

const Quality: React.FC = () => {
  const { t, lang } = useI18n();
  const { single } = useMedia();
  const img = single('quality');
  const [failed, setFailed] = useState(false);
  const [certs, setCerts] = useState<PublicCertification[]>(() => fallbackCertifications(lang));

  useEffect(() => {
    let cancelled = false;
    setCerts(fallbackCertifications(lang));
    PublicApi.certifications(lang)
      .then((d) => { if (!cancelled && d && d.length) setCerts(d); })
      .catch(() => { if (!cancelled) setCerts(fallbackCertifications(lang)); });
    return () => { cancelled = true; };
  }, [lang]);

  return (
    <section id="quality">
      <div className="container">
        <div className="quality-grid">
          <FadeIn variant="left">
            <span className="slabel sl-b">{t('qual.badge')}</span>
            <h2 className="stitle">{t('qual.title')}</h2>
            <p className="ssub">{t('qual.text')}</p>
            <div className="cert-list">
              {certs.map((c) => {
                const Ico = certIcon(c.icon);
                return (
                <div className="cert-item" key={c.id}>
                  <div className="cert-ico"><Ico size={26} color="var(--blue)" aria-hidden /></div>
                  <div>
                    <div className="cert-name">{c.name}</div>
                    <div className="cert-desc">{c.desc}</div>
                  </div>
                </div>
                );
              })}
            </div>
          </FadeIn>
          <FadeIn variant="right" className="qimg-wrap" style={{ transitionDelay: '.15s' }}>
            {img && !failed
              ? <img src={img} alt="Quality Control" width={640} height={420} loading="lazy" decoding="async" onError={() => setFailed(true)} />
              : (
                <div className="qimg-fallback"><ShieldCheck size={64} color="rgba(255,255,255,.55)" aria-hidden /></div>
              )}
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default Quality;
